<script>
	export let song = {};

	let searched = "";
	let ytList = [];

	function loadYT(name) {
		searched = name;
		const link = "https://www.googleapis.com/youtube/v3/search?key=AIzaSyB0mQDznflzEOIP0J-Qy3BgUxsei7Gt0Ek&part=snippet&q=" + encodeURI(name);
		let xhr = new XMLHttpRequest();
		xhr.onreadystatechange = function() {
			if (name != searched)
				return;
			if (this.readyState == 4 && this.status == 200) {
				parseResponse(this.response);
			}
		};
		xhr.open("GET", link, true);
		xhr.send();
	}

	function parseResponse(resp) {
		const videoList = JSON.parse(resp);
		if (videoList.items)
			ytList = videoList.items.slice(0, 5);
	}

	function addVideoLink(id) {
		song = song.addLink("https://youtube.com/watch?v=" + id);
		ytList = [];
	}
</script>

<style>
	.videoitem {
		margin-bottom: 2em;
	}
	.videos {
		transition: height 5s;
	}
</style>

{#if !song.links.some(s => s.includes('youtu'))}
	<div>
		<button on:click={e => loadYT(song.name)}>najít video na YouTube</button>
	</div>
{/if}

<div class="videos">
	{#each ytList as yt}
		<div class="videoitem">
			<div>
				<a href="https://youtube.com/watch?v={yt.id.videoId}" target="_blank">{yt.snippet.title}</a>
				<button on:click={(e) => addVideoLink(yt.id.videoId)}>uložit tohle video</button>
			</div>
			<a href="https://youtube.com/watch?v={yt.id.videoId}" target="_blank">
				<img src="{yt.snippet.thumbnails.medium.url}" alt="{yt.snippet.title}"/>
			</a>
		</div>
	{/each}
</div>
